/**
 * @file
 * Contains bridge export.
 * Needed to connect with native device services.
 */

import {
  saveJwtToken,
  getJwtToken,
  removeJwtToken,
  saveJwtTokenExpires,
  saveJwtRefreshToken,
  getJwtRefreshToken,
  getJwtRefreshTokenExpires,
  saveJwtRefreshTokenExpires,
  getJwtTokenExpires,
  removeJwtRefresh,
} from "./jwtToken.bridge";

const bridge = {
  saveJwtToken,
  getJwtToken,
  removeJwtToken,
  saveJwtTokenExpires,
  saveJwtRefreshToken,
  getJwtRefreshToken,
  getJwtRefreshTokenExpires,
  saveJwtRefreshTokenExpires,
  getJwtTokenExpires,
  removeJwtRefresh,
};

export default bridge;
